<template>
    <Dialog v-model="value" :title="title" @input="$listeners.input" :show-close-button="showCloseButton" :width="dialogWidth">
        <template v-slot:title>
            <span class="dialog_hierarquia_title">{{ title }}</span>
        </template>
        <v-form class="dont_apply_primary_color" ref="formGNRC" @submit.prevent="showConfirmation()">
            <Autocomplete id="gerenteNegocioSelect"
                          label="Gerente de negócio"
                          class="required icone_cor_padrao"
                          v-model="gerenteNegocio"
                          color="default_accent_color"
                          item-color="default_secodary_color"
                          :items="load"
                          :menu-props="{ contentClass: 'rolagemEd', maxHeight: '300px' }"
                          :style="{ '--menuWidth': menuWidth + 'px' }"
                          :hide-selected="false"
                          item-value="value"
                          item-text="label"
                          :cache-items="false"
                          placeholder="Selecione o gerente de negócio"
                          :rules="[$rules.required]"
            />
            <div class="d-flex justify-center mt-4">
                <v-btn color="default_primary_color" style="color:#fff" rounded @click="showConfirmation()">
                    Confirmar
                </v-btn>
            </div>
            <v-form />
        </v-form>
    </Dialog>
</template>

<script>
  import commercialHierarchy from '@/mixins/commercialHierarchy'
  import pontosVendaMixin from '../../mixins/CommercialHierarchy/pontosVendaMixin'
  export default {
    name: 'DialogCommercialHierarchyLogin',
    mixins: [commercialHierarchy, pontosVendaMixin],
    props: {
      value: { type: Boolean, default: true },
      items: { type: Object, default: () => {} },
      logando: { type: Boolean, default: true },
      showCloseButton: { type: Boolean, default: true }
    },
    data: () => ({
      title: 'SELECIONE UM GERENTE DE NEGÓCIO',
      gerenteNegocio: null
    }),
    computed: {
      /** @return Array */
      load () {
        return this.getGerentesNegocio()
      },
      menuWidth () {
        const maiorLabel = Math.max(...this.load.map(i => i.label?.length || 0))
        return Math.max(630, maiorLabel * 8)
      },
      dialogWidth () {
        return this.menuWidth + 25 + 'px'
      },
      showDialog: {
        get () {
          return this.dialog
        },
        set (val) {
          this.$emit('dialog', val)
        }
      }

    },
    watch: {
      'items.listaGerenteNegocio' () {
        if (!this.logando) {
          return
        }
        const items = this.getGerentesNegocio()
        if (items.length === 1) {
          this.$emit('input', false)
          this.gerenteNegocio = items[0].value
          this.confirm()
        }
      }
    },
    methods: {
      showConfirmation () {
        const form = this.$refs.formGNRC
        if (form.validate()) {
          this.isUsuarioFluxoVendas(this.logando, this.confirm, false)
        }
      },
      getGerentesNegocio () {
        if (this.$props?.items?.listaGerenteNegocio) {
          return this.$props.items.listaGerenteNegocio.map(item => {
            return { 'label': item.nomeExibicaoGN, value: item }
          })
        } else {
          return []
        }
      },
      fecharDialog () {
        this.$emit('input', false)
        this.$router.replace('/')
      },
      async confirm () {
        const estruturaComercial = this.gerenteNegocio.estruturaComercial ?? null
        this.$session.set('hierarquia_comercial', {
          ...this.hierarquia_comercial,
          gerenteNegocioSelecionado: this.gerenteNegocio,
          estruturaComercialSelecionada: estruturaComercial
        })
        if (!this.logando) {
          this.resetarEstruturaComercial()
        }

        const pontosVenda = await this.carregarPontosVenda()

        this.$emit('pontosVendaCarregados', pontosVenda)
        this.fecharDialog()
      }
    }
  }
</script>

<style scoped>

.dialog_hierarquia_title {
    width: 100%;
    font-size: 1.2rem;
    text-transform: uppercase;
    color: var(--default_secodary_color);
    text-align: center;
}
</style>

<style>
.rolagemEd {
  white-space: normal;
  overflow-x: hidden !important;
  overflow-y: auto;
  background-color: white;
}

.rolagemEd .v-list-item {
  width: 100%;
  max-width: none;
  line-height: 1.4;
}

.rolagemEd::-webkit-scrollbar {
  height: 6px;
  width: 6px;
}

.rolagemEd::-webkit-scrollbar-thumb{
    background: #5FBEE3 !important;
    border-radius: 4px;
  }
#gerenteNegocioSelect > div > div.v-input__slot > div.v-select__slot > div:nth-child(4) > div > i {
    color:#5FBEE3 !important;
}
</style>
